import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-dashboard-section',
    templateUrl: './dashboard-section.component.html',
    styleUrls: ['./dashboard-section.component.scss']
})
export class DashboardSectionComponent {
    @Input() title = '';
    @Input() dataTest = '';
    @Input() bordered = false;
}
